export const siteNav = [
  { label: "首页", href: "#top", id: "top" },
  { label: "最新深读", href: "#reports", id: "reports" },
  { label: "热点追踪", href: "#hot", id: "hot" },
  { label: "栏目一览", href: "#columns", id: "columns" },
  { label: "深度专题", href: "#deep", id: "deep" },
  { label: "反套路指南", href: "#guide", id: "guide" },
  { label: "常见疑问", href: "#faq", id: "faq" },
  { label: "关于本站", href: "#about", id: "about" },
];

export const heroTicker = [
  "『先享后付』导流乱象调查：分期额度正在流向谁的口袋",
  "直播切片号批量起号背后的MCN灰色流水线",
  "『养生课堂』下沉渠道的会员收割模式拆解",
  "老年旅游『低价团』如何把成本转嫁给购物环节",
  "『自动续费』暗开关：你不知道的扣费潜规则",
];

export interface ReportItem {
  tag: string;
  date: string;
  title: string;
  excerpt: string;
  read: string;
  img: string;
  alt: string;
}

export const latestReports: ReportItem[] = [
  {
    tag: "消费风险",
    date: "09-06",
    title: "『先享后付』的下沉陷阱：分期额度正在流向谁的口袋",
    excerpt:
      "当平台把信用额度包装成『本月先花下月还』的善意，营销链路却在层层导流。我们梳理了从授信到分期的关键节点，看看资金与客群如何被重新定价。",
    read: "8 分钟",
    img: "https://readdy.ai/api/search-image?query=editorial%20photo%20concept%20of%20mobile%20payment%20and%20credit%20cards%20on%20a%20desk%20with%20receipts%20and%20muted%20warm%20paper%20tone%2C%20soft%20studio%20lighting%2C%20neutral%20reportage%20style%2C%20investigative%20journalism%20mood&width=800&height=600&seq=rep01&orientation=landscape",
    alt: "先享后付分期消费调查配图",
  },
  {
    tag: "资本显微镜",
    date: "09-04",
    title: "一条『割韭菜』供应链如何被重新组装：从起盘到退场",
    excerpt:
      "所谓爆品背后常有标准化的操盘脚本。本文把常见的『起盘—造势—裂变—退场』四步走还原出来，帮你识别下一次迎面而来的同款话术。",
    read: "11 分钟",
    img: "https://readdy.ai/api/search-image?query=abstract%20dark%20editorial%20illustration%20of%20interconnected%20business%20network%20nodes%20and%20flow%20lines%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20minimal%20magazine%20cover%20style&width=800&height=600&seq=rep02&orientation=landscape",
    alt: "资本链条拆解示意配图",
  },
  {
    tag: "行业显微镜",
    date: "09-02",
    title: "直播间『砍价剧本』调查：一场没见过的对手戏",
    excerpt:
      "主播与『供货商』当场吵翻、砍到骨折价的桥段，其实大多有固定剧本。我们对比了十几个账号的相似片段，拆解这场戏的成本与分成。",
    read: "9 分钟",
    img: "https://readdy.ai/api/search-image?query=live%20streaming%20studio%20with%20ring%20light%20and%20microphone%20and%20retail%20boxes%2C%20warm%20golden%20tone%2C%20photojournalism%20style%2C%20soft%20shadows%2C%20authentic%20reportage%20mood&width=800&height=600&seq=rep03&orientation=landscape",
    alt: "直播间砍价剧本调查配图",
  },
  {
    tag: "职场潜规则",
    date: "08-30",
    title: "『培训贷』换壳记：从校园到工厂的求职套路演变",
    excerpt:
      "以招聘为名、引导培训分期为实的手法持续换皮。本文梳理其话术模板、目标人群画像与取证要点，给正在找工作的你一份对照清单。",
    read: "7 分钟",
    img: "https://readdy.ai/api/search-image?query=young%20person%20reviewing%20a%20job%20contract%20at%20a%20table%20with%20documents%20and%20laptop%2C%20muted%20warm%20tones%2C%20editorial%20documentary%20photography%2C%20thoughtful%20mood&width=800&height=600&seq=rep04&orientation=landscape",
    alt: "培训贷求职套路调查配图",
  },
  {
    tag: "防骗手册",
    date: "08-27",
    title: "老年人『养生课堂』背后的会销链路：一套可复制的剧本",
    excerpt:
      "先送礼、再讲座、后‘包治百病’……会销的每一环都有成熟打法。这篇文章把它们摊开来看，并给出子女最实用的干预话术。",
    read: "10 分钟",
    img: "https://readdy.ai/api/search-image?query=senior%20people%20listening%20to%20a%20lecture%20in%20a%20community%20hall%20with%20health%20product%20display%2C%20warm%20amber%20lighting%2C%20documentary%20photography%2C%20candid%20reportage&width=800&height=600&seq=rep05&orientation=landscape",
    alt: "会销养生课堂调查配图",
  },
  {
    tag: "消费风险",
    date: "08-24",
    title: "『自动续费』的暗开关：那些你删不掉的扣费入口",
    excerpt:
      "从默认勾选到支付通道前置，再到客服层层设卡，自动续费的设计并不只是粗心。我们实测多家应用的关闭路径，还原扣费潜规则。",
    read: "6 分钟",
    img: "https://readdy.ai/api/search-image?query=closeup%20of%20fingers%20tapping%20a%20smartphone%20showing%20subscription%20settings%20screen%2C%20warm%20desk%20lighting%2C%20editorial%20technology%20reportage%2C%20soft%20background&width=800&height=600&seq=rep06&orientation=landscape",
    alt: "自动续费暗开关调查配图",
  },
];

export interface HotTopic {
  rank: number;
  title: string;
  heat: string;
  trend: "up" | "down" | "flat";
}

export const hotTopics: HotTopic[] = [
  { rank: 1, title: "『加盟稳赚』背后，总部为何总在亏钱", heat: "87.6w", trend: "up" },
  { rank: 2, title: "一只爆款基金的净值曲线，藏着多少『搬运费』", heat: "76.1w", trend: "up" },
  { rank: 3, title: "医美分期：美丽贷的下一个名字", heat: "65.4w", trend: "up" },
  { rank: 4, title: "短视频带货『低价引流』的利润藏在哪", heat: "58.9w", trend: "flat" },
  { rank: 5, title: "考证包过班：贩卖焦虑的产业链条", heat: "49.2w", trend: "up" },
  { rank: 6, title: "『共享经济』返租骗局的旧瓶新酒", heat: "43.7w", trend: "down" },
  { rank: 7, title: "私域团购里的『水军』是怎么雇来的", heat: "38.5w", trend: "flat" },
];

export interface Column {
  name: string;
  en: string;
  icon: string;
  desc: string;
  count: number;
}

export const columns: Column[] = [
  { name: "消费实验室", en: "LAB", icon: "ri-flask-line", desc: "把套路当样本，拿证据做实验。拆解你能接触到的消费陷阱。", count: 128 },
  { name: "资本显微镜", en: "CAPITAL", icon: "ri-scales-3-line", desc: "看穿数字背后的搬运与定价，读懂利益链条如何形成。", count: 96 },
  { name: "行业显微镜", en: "INDUSTRY", icon: "ri-search-eye-line", desc: "深入行业一线，还原那些约定俗成的『潜规则』。", count: 110 },
  { name: "职场潜规则", en: "CAREER", icon: "ri-user-unfollow-line", desc: "求职、晋升与离职的灰色地带，给你可对照的清单。", count: 74 },
  { name: "防骗手册", en: "GUARD", icon: "ri-shield-check-line", desc: "面向普通人可执行的风险识别与止损指南。", count: 152 },
];

export const deepDive = {
  kicker: "深度专题 · 第 23 期",
  title: "直播间『全网最低价』：一场精心编排的定价幻觉",
  dek: "低价从来不是主播的善意，而是一整套供应链与流量定价的精密游戏。我们花了三周梳理选品、让利、佣金与退换货四个环节，还原『最低价』背后的真实账本。",
  img: "https://readdy.ai/api/search-image?query=cinematic%20editorial%20image%20of%20a%20modern%20commerce%20warehouse%20with%20price%20tags%20and%20parcels%20floating%2C%20deep%20warm%20shadows%20with%20amber%20and%20vermillion%20accents%2C%20magazine%20longform%20feature%20visual&width=1600&height=900&seq=deepdive&orientation=landscape",
  alt: "全网最低价直播定价专题主视觉",
  highlights: [
    "选品端：『爆款引流款』与『利润款』如何配比",
    "让利端：品牌补贴与主播让利，谁在真正买单",
    "佣金端：高佣背后对成本的隐性转嫁",
    "售后端：低价商品的退换成本转嫁给了谁",
  ],
  body: [
    "先看选品。一场带货的 SKU 从来不是随机排布，而是运营按照『引流、平销、利润』三档精心排过序的。所谓全网最低价往往只出现在引流款上，它的作用是把你拉进直播间，而真正贡献利润的，是那些你不那么熟悉、单价更高的产品。看懂这张配比表，你就不会再被开场那几个『秒杀价』牵着走。",
    "再看让利。『主播贴钱给你』的说法多数并不成立。品牌方愿意给出定向补贴，是因为主播手里握有流量议价权；而所谓主播让利，也常会以更高的坑位费或佣金率补回来。成本不会凭空消失，只会换一个更隐蔽的位置出现——藏在你的最终成交价里。",
    "然后是佣金与售后。高佣金商品的毛利空间有限，一旦退换货率上升，平台与商家之间就会出现费用转嫁的博弈，最终往往落到那些最容易冲动下单、又最不会较真的消费者身上。低价诱来的冲动消费，恰恰是商家对冲风险的出口。",
    "把四个环节拼起来，你会看到一个结论：『全网最低价』更像一种定价话术，而非真实的让利承诺。判断一场直播值不值得买，与其盯着主播喊出的数字，不如比一比它的日常价、查一查同款在其他渠道的真实行情，再决定要不要为那句口号买单。",
  ],
};

export interface GuideStep {
  icon: string;
  title: string;
  body: string;
}

export const guideSteps: GuideStep[] = [
  {
    icon: "ri-money-cny-circle-line",
    title: "先看『承诺』再掏钱",
    body: "任何过度承诺高回报、无风险、稳赚不赔的表述，都是需要立刻警惕的信号。正规生意从不说满话。",
  },
  {
    icon: "ri-time-line",
    title: "警惕『稀缺』话术",
    body: "『今天不买就没了』『只剩最后三个名额』是在制造焦虑。真正靠谱的机会，不会用倒计时逼你当场决定。",
  },
  {
    icon: "ri-contract-line",
    title: "合同条款逐字看",
    body: "重点确认退款、解约、自动续费与违约金条款。口头承诺写不进合同，就等于不存在。",
  },
  {
    icon: "ri-search-line",
    title: "先查证再行动",
    body: "用公开渠道查主体资质、过往投诉与经营异常记录。查不到、查不清，就先按住自己的钱包。",
  },
  {
    icon: "ri-route-line",
    title: "保留完整证据链",
    body: "截图聊天记录、保存付款凭证、录下关键承诺。一旦需要维权，证据链比情绪有用得多。",
  },
  {
    icon: "ri-refund-line",
    title: "随时能止损退出",
    body: "真正的项目允许你随时抽身。凡是以各种理由阻止你退出、拖延退款的，都要把它当成红线。",
  },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  { q: "呱呱爆料的文章可信吗？内容如何核实？", a: "我们坚持『证据优先』原则，所有深度报道尽量附一手材料、可查证来源或访谈记录。对无法证实的传闻会明确标注『待核实』，绝不把推测写成结论。" },
  { q: "爆料与造谣的区别是什么？", a: "爆料面向可查证的事实并给出证据链，造谣则是无证据的捏造与传播。我们只呈现能讲清出处与因果的客观分析，不进行人格抹黑或无据指控。" },
  { q: "如何判断一个营销套路是不是陷阱？", a: "记住三条底线：过度承诺高回报、制造稀缺焦虑、阻挠你查证或随时抽身，满足任意一条都要警惕。本页的反套路指南会逐条教你拆解。" },
  { q: "发现行业乱象想爆料，如何投稿？", a: "通过页面底部的『线索投递』表单提交，附上时间、主体与初步证据。我们会对线索进行评估核实，并严格保护投稿者信息。" },
  { q: "文章会涉及具体公司或个人吗？", a: "对已公开且证据充分的案例我们会用代号或去标识化处理；对涉及真实主体的内容，仅基于公开资料做中性分析，避免针对性的主观攻击。" },
  { q: "怎么跟进呱呱爆料的最新内容？", a: "订阅页底邮件通讯，或关注官方社交账号，即可第一时间收到深度专题与专栏更新的推送通知。" },
];

export const aboutStats = [
  { label: "深度专题", value: "23", suffix: "期" },
  { label: "核实线索", value: "860", suffix: "+" },
  { label: "原创专栏", value: "560", suffix: "+" },
  { label: "月度读者", value: "120", suffix: "w" },
];

export const testimonials = [
  { quote: "它不贩卖情绪，只摆证据。很多我以为『懂』的套路，读完才发现只是看到表层。", author: "互联网从业者 · 杭州", role: "常驻读者" },
  { quote: "给我爸妈买保健品前，我把防骗手册打印出来逐条核对了，少花了不少冤枉钱。", author: "家庭消费者 · 成都", role: "订阅用户" },
  { quote: "选题扎实，注水极少。在一众标题党里，愿意把利益链条讲清楚的不多。", author: "财经编辑 · 上海", role: "行业读者" },
];

export const principles = [
  { icon: "ri-archive-line", title: "证据优先", body: "先谈出处与来源，再谈结论与判断。" },
  { icon: "ri-scales-line", title: "客观中立", body: "不预设立场，呈现多方视角与因果链。" },
  { icon: "ri-heart-line", title: "保护个体", body: "不泄露隐私，不做针对性的主观攻击。" },
  { icon: "ri-lightbulb-line", title: "讲清逻辑", body: "把复杂的运作，翻译成普通人看得懂的语言。" },
];

export const editorialPrinciples = [
  "内容以公开资料与可核实事实为基础，不捏造指控、不煽动对立",
  "涉及具体主体时去标识化处理，聚焦机制而非针对个人",
  "坚持『证据优先、逻辑透明』，标注待核实事项",
];